import $ from 'jquery';

const propertyCurrent = 'data-submit-text-after';
const propertyProgress = 'data-submit-text';
$('.ui-form').submit(function (e) {
    e.preventDefault();
    if ($(this).hasClass('ui-form--progress')) {
        e.stopPropagation();
        return;
    }
    const text = $(this).attr('data-submit-text') || 'Отправка...';
    let buttonSubmitText = $(this).find('[type="submit"]').last().text();
    $(this).addClass('ui-form--progress');
    $(this).find('.ui-form__error').text('');
    $(this).attr(propertyCurrent, buttonSubmitText);
    $(this).find('[type="submit"]').last().text(text);
    $(this).trigger('ui-submit');
}).on('error', function (e, message) {
    $(this).find('.ui-form__error').text(message).show();
    $(this).removeClass('ui-form--progress');
    $(this).find('[type="submit"]').last().text($(this).attr(propertyCurrent));
}).on('success', function () {
    $(this).removeClass('ui-form--progress');
    $(this).find('[type="submit"]').last().text($(this).attr(propertyCurrent));
});
